module.exports = __webpack_public_path__ + "img/default-image.536ddcbc.jpg";